import { createContext, Dispatch } from 'react'

// TYPES
import { GroupActions, GroupActionTypes } from './types'
import type { IToast } from '@components/molecules/toast'
import type { PaymentIntent, SetupIntent } from '@stripe/stripe-js'


export interface GroupState {
    toast?: IToast
    requestBody: Partial<CreateGroupRequestBody>

    paymentMethod?: CreditCard | ApplePay | GooglePay
    paymentIntent?: PaymentIntent
    setupIntent?: SetupIntent
    /** To a percision of 2 */
    pledgeAmount?: number
    useCreditBalance?: boolean

    /** When the organizer removes an open slot, we need to keep track of it
     * since the group updates after and causes a re-render, which then causes the slot being
     * removed to show again for a split-second since the slot is still in the group.pledges object at that moment
     */
    pledgeToRemove?: string

    isEditingParticipant: boolean
}

export const initState: GroupState = {
    toast: undefined,
    requestBody: {},

    paymentMethod: undefined,
    paymentIntent: undefined,
    setupIntent: undefined,
    pledgeAmount: undefined,
    useCreditBalance: undefined,

    pledgeToRemove: undefined,

    isEditingParticipant: false
}

export function GroupReducer(state = initState, action: GroupActionTypes): GroupState {
    switch (action.type) {
        case GroupActions.SET_TOAST: return { ...state, toast: action.payload }
        
        case GroupActions.RESET_GROUP_STATE: return { ...initState }

        case GroupActions.SET_CREATE_REQUEST_BODY: return { ...state, requestBody: action.payload || {} }
        case GroupActions.UPDATE_CREATE_REQUEST_BODY: return { ...state, requestBody: { ...(state.requestBody || {}), ...action.payload } }

        case GroupActions.SET_PAYMENT_METHOD: return { ...state, paymentMethod: action.payload }
        case GroupActions.ADD_PAYMENT_INTENT: return { ...state, paymentIntent: action.payload }
        case GroupActions.ADD_SETUP_INTENT: return { ...state, setupIntent: action.payload }
        case GroupActions.SET_PLEDGE_AMOUNT: return { ...state, pledgeAmount: action.payload }
        case GroupActions.SET_USE_CREDIT_BALANCE: return { ...state, useCreditBalance: action.payload }

        case GroupActions.SET_REMOVE_PLEDGE: return { ...state, pledgeToRemove: action.payload }

        case GroupActions.SET_EDITING_PARTICIPANT: return { ...state, isEditingParticipant: action.payload }
        default: return state
    }
}

export const GroupContext = createContext<{ localState: GroupState, localDispatch: Dispatch<GroupActionTypes> }>({
    localState: initState,
    localDispatch: () => undefined,
})
